import { resolveAvailableContentLocale } from '../../../functions/public-content-locale.js'

type TranslateFn = (key: string) => string

export const ANNOUNCEMENT_BOARD_SLUG = 'strategy'

export function isAdminEmail(email: string | null | undefined): boolean {
  return email?.trim().toLowerCase().endsWith('@mentiss.ai') ?? false
}

export function canPostToBoard(
  boardSlug: string,
  email: string | null | undefined,
): boolean {
  if (boardSlug === ANNOUNCEMENT_BOARD_SLUG) {
    return isAdminEmail(email)
  }
  return true
}

export function localizedBoardName(
  t: TranslateFn,
  board: { slug: string, name: string },
): string {
  const key = `forum.boardMeta.${board.slug}.name`
  const value = t(key)
  return value === key ? board.name : value
}

export function localizedBoardDescription(
  t: TranslateFn,
  board: { slug: string, description: string },
): string {
  const key = `forum.boardMeta.${board.slug}.description`
  const value = t(key)
  return value === key ? board.description : value
}

export function pickTranslation<T>(
  translations: Record<string, T> | null | undefined,
  language: string,
): T | null {
  if (!translations)
    return null
  const selected = resolveAvailableContentLocale(language, [
    'en',
    ...Object.keys(translations),
  ])
  return selected ? translations[selected] ?? null : null
}
